var methods = require('./mixins/methods');
var computed = require('./mixins/computed');
var directives = require('./mixins/directives');

export default function() {
  return {methods, computed, directives}
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/table.js